import {React} from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { SchoolArray } from '../schools';


export default function  SchoolInput(props) {
  return (
    <Autocomplete
      fullWidth
      onChange={(event, newValue) => {
        props.school(newValue);
      }}
      id="controllable-states-demo"
      options={options}
      getOptionLabel={(option) => option}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Schools"
        />
      )}
    />
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const options = SchoolArray;